import React from 'react';
import { NotificationBanner } from '../elements-banner/notification-banner';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const MyListingBanners = (props) => {
  const onManualPayouts = 'manual' === get(props, 'managedAccount.payout_schedule.interval');
  const submittedBank = 1 <= (_.get(props, 'managedAccount.external_accounts.data') || []).length;
  const hasSpaces = 0 < get(props, 'spaces.data', []).length;

  if (hasSpaces && onManualPayouts && !submittedBank) {
    return (
      <NotificationBanner
        outerBannerClass="fixed-banner"
        backgroundColor="bg-brand-info"
        staticBanner
        message={
          <div className="flex middle space-between">
            <div><FormattedMessage id="hosting.my_listings_banner.add_bank_account_text" defaultMessage="Want to get paid? Add your bank account so we can deposit your payouts."/></div>
            <div>
              <a href="/account/host" className="btn btn-white-outline text-white"><FormattedMessage id="hosting.my_listings_banner.add_payout_link_text" defaultMessage="Add Payout Info"/></a>
            </div>
          </div>
        }
      />
    );
  }
  return null;
};

export default MyListingBanners;
